export default __webpack_public_path__ + "static/media/05.35916041.jpg";